// 비접두(/terms 등) legal 경로 — 감지 언어의 /{ko|en}/{slug} 로 정규화.
// 비접두 경로는 프리렌더하지 않는다: Google OAuth 콘솔 등록 URL 이 /ko/terms 등
// 언어 접두 경로로 확인됐고(2026-06), sitemap/canonical/내부 링크도 모두 접두 경로만 쓴다.
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

export default function LegalLangRedirect({ slug }: { slug: string }) {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'ko' ? 'ko' : 'en';
  return <Navigate to={`/${lang}/${slug}`} replace />;
}
